<navigation [isSticky]="false"></navigation>
<div class="wrapper">
  <div class="container">
    <div class="row">
      <div class="col-xs-12 col-lg-4">
        <malfunction-filter [presetSubscriptionId]="presetSubscriptionId()" [presetProductType]="presetProductType()">
        </malfunction-filter>
      </div>
      <div class="col-xs-12 col-lg-8">
        @if (hasFocusedSubscription()) {
          <webarchive
            [filterSubscriptionName]="filterSubscriptionName()"
            [filterSubscriptionId]="filterSubscriptionId()"
          ></webarchive>
        }

        @if (!hasFocusedSubscription() && hasTicketsAvailable()) {
          <div>
            <h3>
              {{ "Malfunction.Default.Filter.Title" | translate }}
              @if (hasFocusedProductType()) {
                {{ filterProductTypeKey() | translate }}
              }
            </h3>
          </div>
        }
        @if (activeTicketsHeading()) {
          <h3 class="now-active__header">{{ "Malfunction.NowActive" | translate }}</h3>
        }

        @for (ticket of majorDisruptionTicketsOpen(); track ticket.id) {
          <malfunction-card [message]="ticket" [isMajorDisruption]="true" [showTimeElement]="false"></malfunction-card>
        }

        @if (activeTicketsHeading()) {
          <h3 class="now-active__header">{{ "Malfunction.Timeline" | translate }}</h3>
        }

        @for (ticket of filteredTicketsActive(); track ticket.id) {
          <malfunction-card [message]="ticket" [showTimeElement]="false"></malfunction-card>
        }

        <div class="timeline" [class.loading]="loading">
          @for (ticketsInactivePerDay of filteredTicketsInactive(); track $index) {
            @for (ticket of ticketsInactivePerDay; track ticket.id) {
              <malfunction-card [message]="ticket" [showTimeElement]="$index === 0"></malfunction-card>
            }
          }
        </div>
        @if (!loading) {
          <timeline-footer [showEmptyState]="!hasTicketsAvailable()" [hasMoreResults]="hasMore"></timeline-footer>
        } @else {
          <loader />
        }
      </div>
    </div>
    <footer></footer>
  </div>
</div>
